import React, {useEffect, useRef, useState} from "react";

import InvestorsLogo from "components/AboutUsNew/Investors";
import styled from "styled-components";

const InvestorSection = ({investorData = {}}) => {
  const {title = "", investors = []} = investorData;
  const [isMobile, setIsMobile] = useState(false);
  const carouselRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    if (!isMobile || !carouselRef.current) return;

    let logoIndex = 0;
    const logoCount = investors.length;
    const container = carouselRef.current;

    const scroll = () => {
      const logoNode = container.children[logoIndex];
      if (logoNode) {
        const left = logoNode.offsetLeft;
        container.scrollTo({left, behavior: "smooth"});
      }
      logoIndex = (logoIndex + 1) % logoCount;
    };

    const interval = setInterval(scroll, 2000);
    return () => clearInterval(interval);
  }, [isMobile, investors.length]);

  return (
    <Section>
      <SectionInner>
        <SectionTitleCenterInvester>{title}</SectionTitleCenterInvester>
        {isMobile ? (
          <MobileCarousel>
            <CarouselContainer ref={carouselRef}>
              {investors.map((investor, index) => (
                <InvestorsLogo
                  isActive
                  image={investor.image}
                  key={index}
                />
              ))}
            </CarouselContainer>
          </MobileCarousel>
        ) : (
          <InvestorsRow>
            {investors.map((investor, index) => (
              <InvestorsLogo
                isActive
                image={investor.image}
                key={index}
              />
            ))}
          </InvestorsRow>
        )}
      </SectionInner>
    </Section>
  );
};

const MobileCarousel = styled.div`
  width: 100%;
  overflow-x: auto;
  margin-bottom: 4rem;

  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const CarouselContainer = styled.div`
  display: flex;
  gap: 2rem;
  width: max-content;
  min-width: 100%;
  align-items: center;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const InvestorsRow = styled.div`
  display: flex;
  width: 75%;
  margin: 0 auto;
  gap: 2rem;
  padding-top: 2rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  box-sizing: border-box;

  @media (max-width: 768px) {
    gap: 1.77rem;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    min-height: unset;
    margin-bottom: 2.66rem;
  }
`;

const Section = styled.section`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 10rem;

  @media (max-width: 768px) {
    margin-top: 3rem;
  }
`;

const SectionInner = styled.div`
  width: 90%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media (max-width: 768px) {
    width: 90%;
    padding: 0 4px;
  }
`;

const SectionTitleCenterInvester = styled.h2`
  margin-top: 4rem;
  font-family: 'DM Serif Display';
  font-size: 5rem;
  font-weight: 400;
  width: 100%;
  margin: auto;
  color: #1C1C1C;
  text-align: center;

  @media (max-width: 700px) {
    font-size: 2.7rem;
    margin-top: 2.4rem;
    margin-bottom: 2rem;
    width: 22.5rem;
  }
`;

export default InvestorSection;
